import './PageContainer.scoped.scss'

const statusMap = {
    'live': 'Live',
    'draft': 'Draft',
    'closed': 'Closed',
}

export default function OverviewSection() {
  const dashboard = useSel((s) => s.dashboard)

  return (
    <div className='box gap' id='status'>
        <div className="poster-container">
            <div className="poster">
                {/* Iframe here in future once preview is setup */}
            </div>
        </div>
        <div className='main'>
            <div className='header row'>
                <h1 className='no-margin-top'>Dashboard { statusMap[dashboard?.status] || '' }</h1>
            </div>

        </div>
    </div>
  )
}
